import * as React from "react";
import FormWarningsProvider from "contexts/FormWarningsProvider";
import EventDefinitionTrafficForm from "./EventDefinitionTrafficForm";
const EventDefinitionTrafficFormContainer = (props) => {
  const { eventDefinition, onChange, validation } = props;
  return /* @__PURE__ */ React.createElement(FormWarningsProvider, null, /* @__PURE__ */ React.createElement(
    EventDefinitionTrafficForm,
    {
      eventDefinition,
      onChange,
      validation
    }
  ));
};
export default EventDefinitionTrafficFormContainer;
